import React from "react";
import Marquee from "react-fast-marquee";

const LENDERS = ["iwoca", "Funding Circle", "Aurora Capital", "Funding Options", "Bizcap", "Animo Finance", "Tide", "Capify"];
const BXB_LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_business-loan-quote/artifacts/n2g01nxn_WhatsApp%20Image%202026-09-07%20at%201.27.44%20PM.jpeg";

export const TrustMarquee = () => (
  <div className="border-y border-[#052F24]/10 bg-white py-6">
    <p className="text-center text-[11px] font-bold tracking-[0.25em] uppercase text-[#052F24]/40 mb-5">
      Trusted by top UK FCA-regulated lenders and Brokers
    </p>
    <Marquee speed={40} gradient gradientColor="#FFFFFF" gradientWidth={80}>
      <img
        src={BXB_LOGO}
        alt="BusinessXBridge"
        className="h-20 w-auto object-contain mx-10 opacity-40 grayscale"
        data-testid="lender-logo-businessxbridge"
      />
      {LENDERS.map((n) => (
        <span key={n} className="font-display font-extrabold text-2xl text-[#052F24]/25 mx-10 tracking-tight">
          {n}
        </span>
      ))}
    </Marquee>
  </div>
);
